import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
    zIndex: 9,
  },
  large: {
    width: (props) => theme.spacing(props.size),
    height: (props) => theme.spacing(props.size),
    border: "2px solid #fff",
  },
}));

export default function UserAvatar({ size = 7 }) {
  const classes = useStyles({ size });

  const userName = "James Master";

  return (
    <div className={classes.root}>
      <Avatar
        alt={`${userName} image profile`}
        src="/static/images/avatar/1.jpg"
        className={classes.large}
      />
    </div>
  );
}
